import { defaultToastifyCSS, BKJToastOuterWrapperCSS, BKJToastBodyCSS, BKJToastProgressBarCSS, BKJToastCloseButtonCSS, } from './BKJToastMessage.styled.js';
import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';
export const BKJToastContainer = styled(ToastContainer) `
  ${defaultToastifyCSS}
  .Toastify__toast {
    ${BKJToastOuterWrapperCSS};
  }
  .Toastify__toast-body {
    ${BKJToastBodyCSS}
  }
  .Toastify__progress-bar {
    ${BKJToastProgressBarCSS}
  }
  .Toastify__close-button {
    ${BKJToastCloseButtonCSS}
  }
`;
//# sourceMappingURL=BKJToastContainer.js.map